<template>
  <router-view />
</template>

<script>
export default {
  name: 'KernelPressSheetsWrapper',
};
</script>
